import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { UrgencyModel } from './model';

export const urgencyAdapter: EntityAdapter<UrgencyModel> = createEntityAdapter<UrgencyModel>({
  selectId: model => model.id,
  sortComparer: (a: UrgencyModel, b: UrgencyModel): number => a.sortOrder - b.sortOrder,
});

export interface UrgencyState extends EntityState<UrgencyModel> {
  isLoading?: boolean;
  error?: any;
}

export const initialState: UrgencyState = urgencyAdapter.getInitialState({
  isLoading: false,
  error: null,
});
